<template>
  <div>
    <el-drawer v-loading="loading" title="投标申请" :visible.sync="show" size="90%" :before-close="handleClose" destroy-on-close center :close-on-click-modal="false">
      <el-form ref="form" :disabled="type == '查看'" :model="form" :rules="rules" label-width="130px">
        <el-card header="基础信息">
          <el-row>
            <el-col :span="6">
              <el-form-item label="投标单号" prop="sn">
                <el-input v-model="form.sn" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单状态" prop="bidStatus">
                <el-select v-model="form.bidStatus" :disabled="true" clearable placeholder="自动生成">
                  <el-option v-for="item in statusOptions" :key="item.code" :value="item.code" :label="item.name" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createTime">
                <el-date-picker v-model="form.createTime" :disabled="true" type="datetime" placeholder="自动生成" value-format="yyyy-MM-dd HH:mm:ss" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createUser">
                <el-input v-model="form.createUser" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="投标名称" prop="bidName">
                <el-input v-model="form.bidName" :disabled="isRejectTo" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="招标开始时间" prop="bidStartDate">
                <el-date-picker v-model="form.bidStartDate" :disabled="isRejectTo" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="招标截止时间" prop="bidEndDate">
                <el-date-picker v-model="form.bidEndDate" :picker-options="startPickerOptions" :disabled="isRejectTo && type!=='修改时间'" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单类型" prop="orderType">
                <el-select v-model="form.orderType" clearable placeholder="请选择" :disabled="isRejectTo">
                  <el-option v-for="item in orderTypeOptions" :key="item.code" :value="item.code" :label="item.name" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投标简介" prop="bidIntro">
                <el-input v-model="form.bidIntro" :disabled="isRejectTo" type="textarea" placeholder="请输入" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card header="投标明细">
          <el-tabs v-model="activePaneName">
            <!-- <el-tab-pane label="配件" name="mountings">
              <div style="margin-bottom: 10px;display: flex;justify-content: flex-end;">
                <el-button type="primary" @click="addMountingsLine()">新增配件</el-button>
                <el-button type="danger" @click="delectMountingsLine()">一键清空配件列表</el-button>
              </div>
              <el-table v-if="!showObj.mountings" ref="mountingsTable" height="400px" :data="form.mountingsList" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="订单数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'mountingsList.' + scope.$index + '.qty'
                      " :rules="mountingsList.qty">
                      <el-input v-model="scope.row.qty" placeholder="请输入" min="0" type="number" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="批次号" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="batch">
                      <el-input v-model="scope.row.batch" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="预计提货时间" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'mountingsList.' + scope.$index + '.predictPickDate'
                      " :rules="mountingsList.predictPickDate">
                      <el-date-picker v-model="scope.row.predictPickDate" type="date" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="图片" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item>
                      <el-image style="width: 100px; height: 60px" :src="scope.row.previewArr[0]" :preview-src-list="scope.row.previewArr">
                        <div slot="error" class="image-slot" style="width: 100px; height: 60px;line-height: 60px;text-align: center;">
                          <i class="el-icon-picture-outline" />暂无数据
                        </div>
                      </el-image>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="说明" align="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" @click="handleFormula(scope.$index,'mountingsList')">添加公式</el-button>
                    <el-button type="text" @click="handleUploadPictures(scope.$index,'mountingsList')">上传图片</el-button>
                    <el-button type="text" @click="handleMountingsDelete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane> -->
            <el-tab-pane label="废料" name="flotsam">
              <div style="margin-bottom: 10px;display: flex;justify-content: flex-end;">
                <el-button type="primary" @click="addFlotsamLine()">新增废料</el-button>
                <el-button type="danger" @click="delectFlotsamLine()">一键清空废料列表</el-button>
              </div>
              <el-table v-if="!showObj.flotsam" ref="flotsamTable" height="400px" :data="form.flotsamList" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="订单数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'flotsamList.' + scope.$index + '.qty'
                      " :rules="flotsamList.qty">
                      <el-input v-model="scope.row.qty" placeholder="请输入" :disabled="isRejectTo" min="0" type="number" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="拆解类型" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="separateType">
                      {{ format.formatEnumDesc('Separate_Type_Code',scope.row.separateType) }}
                    </el-form-item>
                  </template>
                </el-table-column> -->
                <el-table-column label="批次号" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="batch">
                      <el-input v-model="scope.row.batch" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="预计提货时间" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="" :prop="
                        'flotsamList.' + scope.$index + '.predictPickDate'
                      " :rules="flotsamList.predictPickDate">
                      <el-date-picker v-model="scope.row.predictPickDate" :disabled="isRejectTo" type="date" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="图片" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item>
                      <el-image style="width: 100px; height: 60px" :disabled="isRejectTo" :src="scope.row.previewArr[0]" :preview-src-list="scope.row.previewArr">
                        <div slot="error" class="image-slot" style="width: 100px; height: 60px;line-height: 60px;text-align: center;">
                          <i class="el-icon-picture-outline" />暂无数据
                        </div>
                      </el-image>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="额外参考物料" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    {{ scope.row.rdmWasteName || '请选择' }}
                    <!-- <el-form-item prop="rdmWasteName">

                      <el-input v-model="scope.row.rdmWasteName" :disabled="true" placeholder="请选择" />
                    </el-form-item> -->
                  </template>
                </el-table-column>
                <el-table-column label="说明" align="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" :disabled="isRejectTo" placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="200">
                  <template slot-scope="scope">
                    <!-- v-permission="'tender:tenderApplication:index:selectClient'" -->
                    <span v-if="form.bidStatus>=3" class="blueBtn" :disabled="isRejectTo" @click="handleFormula(scope.row)">添加公式</span>
                    <span v-if="form.bidStatus == 3 || form.bidStatus == 4" class="blueBtn" @click="selectClient(scope.row.id,form.bidStatus)">选择客户</span>

                    <el-button type="text" :disabled="isRejectTo" @click="addRdmWaste(scope.$index,)">外部参考物料</el-button>
                    <el-button type="text" :disabled="isRejectTo" @click="handleUploadPictures(scope.$index,'flotsamList')">上传图片</el-button>
                    <el-button type="text" :disabled="isRejectTo" @click="handleFlotsamDelete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-card>
        <!-- v-if="form.status != 3" -->
        <el-card header="流程审批">
          <div v-if="form.status <= 1 || form.status==null">
            <el-row>
              <el-col :span="8">
                <el-form-item label="选择流程模板" prop="flowPathTemplateId">
                  <el-select v-model="form.flowPathTemplateId" placeholder="选择模板" :disabled="isRejectTo" @change="getFlowTempInfoList">
                    <el-option v-for="item in flowPathOptions" :key="item.id" :label="item.templateName" :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col>

            </el-row>
            <el-table v-if="form.flowPathNodePersonModels && form.flowPathNodePersonModels.length>0" ref="elTable" style="width:50%" :data="form.flowPathNodePersonModels" border>
              <el-table-column label="节点名称" align="left" show-overflow-tooltip width="150">
                <template slot-scope="scope">
                  <el-form-item prop="nodePersonName">
                    {{ scope.row.nodePersonName }}
                    <!-- <el-input
                      v-model="scope.row.companyName"
                      disabled
                    /> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="审批人" align="left" show-overflow-tooltip width="auto">
                <template slot-scope="scope">
                  <el-form-item :prop="
                      'flowPathNodePersonModels.' + scope.$index + '.nodePerson'
                    " :rules="flowPathNodePersonModels.nodePerson">
                    <el-input v-model="scope.row.nodePerson" readonly placeholder="请点击图标选择">
                      <el-button v-if="scope.row.variable" slot="append" :disabled="isRejectTo" icon="el-icon-search" @click="selectNodePerson(scope.$index)" />
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="deleteNodePerson(scope.$index)"
                  >删除</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
          <Flow ref="flow" :disabled="type == '查看' || form.status > 2" :custom-event="true" :flow-id="form.flowId" @flowLoad="flowLoad" @complete="onComplete" @refresh="flowRefresh" @rejectTo="flowRejectTo" />
        </el-card>
        <el-row style="padding: 10px 20px">
          <el-button :disabled="isRejectTo && type!=='修改时间'" :loading="loading" type="primary" @click="submitForm('form',false)">保存</el-button>
          <el-button v-if="form.id && (form.status == 1 || !form.status)" :disabled="isRejectTo" type="primary" @click="saveAndSubmit()">提交</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-row>
      </el-form>
    </el-drawer>
    <!-- 产品配料 -->
    <el-dialog class="dialog" title="产品配料" :visible.sync="showObj.mountings" width="70%" :before-close="mountingsClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="5">
          <el-input v-model="condition.mountings.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="5">
          <el-input v-model="condition.mountings.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="5">
          <el-input v-model="condition.mountings.oeCode" clearable placeholder="请输入OE" />
        </el-col>
        <el-col :span="5">
          <el-input v-model="condition.mountings.carNo" clearable placeholder="请输入车牌" />
        </el-col>
        <el-col :span="4">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getMountings('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.mountings" :data="dialog.mountings" border height="300" @selection-change="handleMountingsChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" show-overflow-tooltip />
        <el-table-column label="OE" align="left" prop="oeCode" show-overflow-tooltip />
        <el-table-column label="车辆ID" align="left" prop="carId" show-overflow-tooltip />
        <el-table-column label="车牌" align="left" prop="carNo" show-overflow-tooltip />
        <el-table-column label="品牌" align="left" prop="brand" show-overflow-tooltip />
        <el-table-column label="车系" align="left" prop="series" show-overflow-tooltip />
        <el-table-column label="年款" align="left" prop="modelYear" show-overflow-tooltip />
        <!-- <el-table-column
          label="燃料类型"
          align="left"
          prop="oeCode"
          show-overflow-tooltip
        /> -->
        <el-table-column label="发动机型号" align="left" prop="engineModel" show-overflow-tooltip />
        <el-table-column label="变速箱型号" align="left" prop="transmissionModel" show-overflow-tooltip />
        <el-table-column label="排量" align="left" prop="displacement" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.mountings.total" :page.sync="pagination.mountings.current" :limit.sync="pagination.mountings.size" @pagination="getMountings" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mountingsClose">取消</el-button>
        <el-button type="primary" @click="mountingsConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 产品废料 -->
    <el-dialog class="dialog" title="产品废料" :visible.sync="showObj.flotsam" width="60%" :before-close="flotsamClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.flotsam.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.flotsam.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getFlotsam('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.flotsam" :data="dialog.flotsam" border height="300" @selection-change="handleFlotsamChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.flotsam.total" :page.sync="pagination.flotsam.current" :limit.sync="pagination.flotsam.size" @pagination="getFlotsam" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="flotsamClose">取消</el-button>
        <el-button type="primary" @click="flotsamConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 上传图片 -->
    <el-dialog class="dialog" title="上传图片" :visible.sync="showObj.pictures" width="60%" :before-close="picturesClose" destroy-on-close center :close-on-click-modal="false">
      <el-row v-if="picturesType">
        <FileUpload :value.sync="form[picturesType][picturesIndex].crmBidModuleOrderAccessoryModels" :file-type="['png', 'jpg', 'jpeg']" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="picturesClose">确认</el-button>
      </span>
    </el-dialog>
    <!-- 选择审批人 -->
    <el-dialog class="dialog" :title="'选择审批人'" :visible.sync="showObj.nodePerson" width="40%" :before-close="nodePersonClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.nodePerson.nodePerson" clearable placeholder="请输入审批人名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getNodePersonDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.nodePerson" border height="300" @selection-change="handleNodePersonSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="审批人" align="left" prop="nodePerson" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.nodePerson.total" :page.sync="pagination.nodePerson.current" :limit.sync="pagination.nodePerson.size" @pagination="getNodePersonDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="nodePersonClose">取消</el-button>
        <el-button type="primary" @click="nodePersonConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 添加公式 -->
    <el-drawer class="dialog" title="添加公式" :visible.sync="showObj.formula" size="70%" :before-close="formulaClose" destroy-on-close center :wrapper-closable="false" :close-on-click-modal="false">
      <el-card v-for="(item,index) in formulaArr" :key="item.id">
        <div slot="header" class="clearfix" style="display: flex; justify-content: space-between;">
          <span>公式{{ index+1 }}：{{ item.formula }}（不含税价）</span>
          <el-button v-if="![2,'2'].includes(form.makeOffersStatus)" type="primary" @click="addformulaLine(index)">新增含税价描述</el-button>
        </div>
        <el-row v-for="(v,i) in item.crmBidFormulaTemplateLineModels || []" :key="i" style="margin-top: 5px;">
          <el-col :span="18">
            <el-input v-model="v.note" :disabled="[2,'2'].includes(form.makeOffersStatus)" placeholder="请填写含税价描述" />
          </el-col>
          <el-col v-if="![2,'2'].includes(form.makeOffersStatus)" :span="4">
            <el-button type="danger" style="margin-left: 20px;" @click="handleDormulaDelete(index,i)">删除</el-button>
          </el-col>
        </el-row>
        <!-- <el-table ref="listTable" v-loading="loading.formula" :data="item.crmBidFormulaTemplateLineModels" border height="300">
          <el-table-column type="index" label="序号" width="50" />
          <el-table-column label="含税价描述" align="left" prop="nodePerson">
            <template slot-scope="scope">
              <el-input v-model="scope.row.note" placeholder="请填写含税价描述" />
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="50">
            <template slot-scope="scope">
              <el-button type="text" @click="handleDormulaDelete(i,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table> -->
      </el-card>
      <div style="display: flex;justify-content: center;margin-top: 10px; ">
        <el-button v-if="![2,'2'].includes(form.makeOffersStatus)" type="primary" @click="submitFormula">保存</el-button>
        <el-button @click="formulaClose">关闭</el-button>
      </div>

      <!-- <span slot="footer" class="dialog-footer">

      </span> -->
    </el-drawer>
    <!-- 外部参考物料 -->
    <el-dialog class="dialog" title="外部参考物料" :visible.sync="showObj.rdmWaste" width="60%" :before-close="rdmWasteClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.rdmWaste.rdmWasteName" clearable placeholder="请输入外部参考物料" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getRdmWaste('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.rdmWaste" :data="dialog.rdmWaste" border height="300" @selection-change="handleRdmWasteChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="外部参考物料编码" align="left" prop="code" width="150" show-overflow-tooltip />
        <el-table-column label="外部参考物料名称" align="left" prop="name" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.rdmWaste.total" :page.sync="pagination.rdmWaste.current" :limit.sync="pagination.rdmWaste.size" @pagination="getRdmWaste" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rdmWasteClose">取消</el-button>
        <el-button type="primary" @click="rdmWasteConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!--已选客户 -->
    <el-dialog class="dialog" :title="'已选客户'" :visible.sync="showObj.client" width="70%" :before-close="clientClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.client.customerApplyName" clearable placeholder="请输入客户名称" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.client.customerApplyNo" clearable placeholder="请输入客户编码" />
        </el-col>
        <el-col :span="6">
          <el-select v-model="condition.client.customerType" clearable placeholder="请选择客户类型">
            <el-option v-for="item in customerType" :key="item.code" :value="item.code" :label="item.name" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select v-model="condition.client.operateCategory" clearable placeholder="请选择经营类别">
            <el-option v-for="item in businessCategory" :key="item.code" :value="item.code" :label="item.name" />
          </el-select>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" icon="el-icon-search" @click="getClientDialog('refresh')">查询</el-button>
          <el-button style="margin-left: 10px;margin-top: 5px;margin-bottom: 5px; " type="primary" @click="selectPublish()">选择客户</el-button>
          <el-button type="primary" style="margin-left: 10px;" @click="publishConfirmAll">选择所有客户</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.client" :data="dialog.client" border height="300" @selection-change="handleClientSelectionChange">
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="客户编码" align="left" prop="customerApplyNo" show-overflow-tooltip width="120" />
        <el-table-column label="客户名称" align="left" prop="customerApplyName" show-overflow-tooltip width="120" />
        <el-table-column label="客户类型" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.customerType == 1">固定</span>
            <span v-if="scope.row.customerType == 2">零星</span>
          </template>
        </el-table-column>
        <el-table-column label="经营类别" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.operateCategory | operateCategoryFilters }}
          </template>
        </el-table-column>
        <el-table-column label="业务员" align="left" prop="salesman" show-overflow-tooltip />

        <el-table-column label="操作" fixed="right" width="80">
          <template slot-scope="scope">
            <el-button v-if="bidModuleOrderType==3 || bidModuleOrderType==4" type="text" @click="handleClientDelete(scope.row.crmBidModuleCustomerId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.client.total" :page.sync="pagination.client.current" :limit.sync="pagination.client.size" @pagination="getClientDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clientClose">关闭</el-button>
        <!-- <el-button type="primary" @click="clientConfirm">确认</el-button>
        <el-button type="primary" @click="clientConfirmAll">推送所有客户</el-button> -->
      </span>
    </el-dialog>
    <!--客户列表 -->
    <el-dialog class="dialog" :title="'选择客户'" :visible.sync="showObj.publish" width="70%" :before-close="publishClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="4">
          <el-input v-model="condition.publish.customerApplyName" clearable placeholder="请输入客户名称" />
        </el-col>
        <el-col :span="4">
          <el-input v-model="condition.publish.customerApplyNo" clearable placeholder="请输入客户编码" />
        </el-col>
        <el-col :span="4">
          <el-select v-model="condition.publish.customerType" clearable placeholder="请选择客户类型">
            <el-option v-for="item in customerType" :key="item.code" :value="item.code" :label="item.name" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="condition.publish.operateCategory" clearable placeholder="请选择经营类别">
            <el-option v-for="item in businessCategory" :key="item.code" :value="item.code" :label="item.name" />
          </el-select>
        </el-col>

        <el-col :span="4">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getPublishDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.publish" :data="dialog.publish" border height="300" @selection-change="handlePublishSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="客户编码" align="left" prop="customerApplyNo" show-overflow-tooltip width="120" />
        <el-table-column label="客户名称" align="left" prop="customerApplyName" show-overflow-tooltip width="120" />
        <el-table-column label="客户类型" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.customerType == 1">固定</span>
            <span v-if="scope.row.customerType == 2">零星</span>
          </template>
        </el-table-column>
        <el-table-column label="经营类别" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.operateCategory | operateCategoryFilters }}
          </template>
        </el-table-column>
        <el-table-column label="业务员" align="left" prop="salesman" show-overflow-tooltip />

        <!-- <el-table-column label="联系人" align="left" prop="contacts" show-overflow-tooltip />
        <el-table-column label="联系方式" align="left" prop="contactsPhone" show-overflow-tooltip /> -->
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.publish.total" :page.sync="pagination.publish.current" :limit.sync="pagination.publish.size" @pagination="getPublishDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="publishClose">关闭</el-button>
        <el-button type="primary" @click="publishConfirm">确认</el-button>

      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  get,
  saveOrUpdate,
  submit,
  templateFormulaGet,
  templateFormulaSaveOrUpdate,
  selectWastePage,
  getCustomerApplyModels,
  publishesAll,
  publishes,
  getCustomerBidPage,
  deleteByCustomerBidId
} from '@/api/crm/tender/tenderApplication'
import { mergeObjectArrayWithoutDuplicates } from '@/utils/index'
import Pagination from '@/components/Pagination'
import Flow from '@/components/Flow'
import FileUpload from '@/components/FileUpload/index'
import format from '@/utils/formatter'
import { getByPathTemplate, getFlowTempInfo } from '@/api/flow/processConfiguration'
import { getEnumItems } from '@/utils/enum'
import { getPagePopup as getMountingsApi } from '@/api/crm/product/fittings'
import { getPageListPopup as getFlotsamApi } from '@/api/crm/product/scraps'
import { getByGeneralManager } from '@/api/crm/base/audit'
export default {
  name: 'TenderApplicationEdit',
  components: {
    Pagination,
    FileUpload,
    Flow
  },
  filters: {

    operateCategoryFilters(e) {
      const arr = e.split(',')
      const arr1 = getEnumItems('Crm_Business_Category')
      const arr2 = []
      for (const item of arr) {
        for (const v of arr1) {
          if (v.code === item) {
            arr2.push(v.name)
          }
        }
      }
      console.log(arr2.join())
      return arr2.join()
    }
  },
  props: {
    show: {
      type: Boolean,
      default() {
        return false
      }
    },
    editId: Number
  },
  data() {
    return {
      format: format,
      type: '',
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL,
      appUrl: process.env.VUE_APP_URL,
      loading: false,
      form: {
        flotsamList: [],
        mountingsList: [],
        salesOrganizationId: null,
        channelOfDistributionId: null,
        productTeamId: null,
        salesCode: null,
        soldToPartyName: null,
        flowPathNodePersonModels: [],
        flowPathTemplateId: null,
        bidEndDate: null
      },
      flowPathNodePersonModels: {
        nodePerson: [
          { required: true, message: '审批人不能为空', trigger: 'change' }
        ]
      },
      mountingsList: {
        qty: [
          { required: true, message: '配件数量不能为空', trigger: 'blur' }
        ],
        predictPickDate: [
          { required: true, message: '预计提货时间不能为空', trigger: 'blur' }
        ]
      },
      flotsamList: {
        qty: [
          { required: true, message: '废料数量不能为空', trigger: 'blur' }
        ],
        predictPickDate: [
          { required: true, message: '预计提货时间不能为空', trigger: 'blur' }
        ]
      },
      rules: {
        bidName: [
          { required: true, message: '投标名称不能为空', trigger: 'blur' }
        ],
        bidStartDate: [
          { required: true, message: '招标开始时间不能为空', trigger: 'change' }
        ],
        bidEndDate: [
          { required: true, message: '招标截止时间不能为空', trigger: 'change' }
        ],
        orderType: [
          { required: true, message: '订单类型不能为空', trigger: 'change' }
        ]
      },
      activePaneName: 'flotsam',
      showObj: {
        mountings: false,
        flotsam: false,
        nodePerson: false,
        pictures: false,
        formula: false,
        rdmWaste: false,
        client: false,
        publish: false
      },
      loadingObj: {
        mountings: false,
        flotsam: false,
        nodePerson: false,
        formula: false,
        rdmWaste: false,
        client: false,
        publish: false
      },
      // 分页
      pagination: {
        mountings: {
          total: 0,
          size: 20,
          current: 1
        },
        nodePerson: {
          total: 0,
          size: 20,
          current: 1
        },
        flotsam: {
          total: 0,
          size: 20,
          current: 1
        },
        formula: {
          total: 0,
          size: 20,
          current: 1
        },
        rdmWaste: {
          total: 0,
          size: 20,
          current: 1
        },
        client: {
          total: 0,
          size: 20,
          current: 1
        },
        publish: {
          total: 0,
          size: 20,
          current: 1
        }
      },
      dialog: {
        mountings: [],
        flotsam: [],
        nodePerson: [],
        formula: [],
        rdmWaste: [],
        client: [],
        publish: []
      },
      condition: {
        mountings: {},
        flotsam: {},
        nodePerson: {},
        rdmWaste: {},
        client: {},
        publish: {}

      },
      selection: {
        mountings: [],
        flotsam: [],
        nodePerson: [],
        formula: [],
        rdmWaste: [],
        client: [],
        publish: []
      },
      nodePersonIndex: null,
      isDisabled: false,
      isRejectTo: false,
      statusOptions: getEnumItems('Crm_Tender_Status'),
      picturesIndex: null,
      picturesType: null,
      flowPathOptions: [],
      orderTypeOptions: [{ code: 1, name: '废料投标' }, { code: 2, name: '配件投标' }],
      formulaArr: [],
      rdmWasteIndex: null,
      bidModuleOrderLineId: null,
      bidModuleOrderType: null,
      customerType: getEnumItems('Crm_Customer_Type'),
      businessCategory: getEnumItems('Crm_Business_Category')
      // { lordDutyPrice: null, taxRatio: null, taxlessPrice: null }
      // mountingsList: [],
      // flotsamList: []

    }
  },
  computed: {
    startPickerOptions() {
      const nowdate = format.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')
      // 选择的日期
      const curDate = this.form.bidEndDate ? this.form.bidEndDate.split(' ')[0] : nowdate.split(' ')[0]
      // 最小日期
      const minDate = nowdate.split(' ')[0]
      // 前推一天，防止当天日期无法选择
      const preTime = new Date().getTime() - 24 * 3600000
      // 如果选择的日期为最小日期，则设置为最小日期的时分秒
      let str = ''
      console.log(curDate, minDate)
      if (curDate == minDate) {
        str = nowdate.split(' ')[1]
        if (new Date(this.form.bidEndDate).getTime() < new Date(nowdate).getTime()) {
          this.form.bidEndDate = this.form.bidEndDate ? curDate + ' ' + str : null
        }
      } else {
        str = '00:00:00'
      }
      // this.form.bidEndDate = this.form.bidEndDate ? curDate + ' ' + str : null
      console.log(this.form.bidEndDate)
      console.log(str + ' - 23:59:59')
      return {
        selectableRange: str + ' - 23:59:59',
        disabledDate: (time) => {
          return time.getTime() < preTime
        }
      }
    }
  },
  watch: {
    show(show) {
      if (!show) {
        return
      }
      this.init()
      this.flowPathNodePersonModels.nodePerson[0].required = false
      if (this.editId == null) {
        this.form = this.$options.data.call(this).form
        return
      }
      this.getData()
    }
  },
  methods: {

    init() {
      getByPathTemplate({ templateType: '投标' }, { current: 1, size: 100 }).then((res) => {
        const { records } = res.data
        this.flowPathOptions = records
        console.log(this.flowPathOptions)
      })
    },
    // 审批人
    async getNodePersonDialog() {
      this.loadingObj.nodePerson = true
      const reponse = await getByGeneralManager(this.condition.nodePerson.nodePerson, this.form.roleId, this.pagination.nodePerson)
      const { current, total, size, records } = reponse.data
      this.dialog.nodePerson = records
      this.pagination.nodePerson.total = total
      this.pagination.nodePerson.current = current
      this.pagination.nodePerson.size = size
      this.loadingObj.nodePerson = false
    },
    async getFlowTempInfoList(e) {
      this.loading = true
      this.form.flowPathNodePersonModels = []
      const i = this.flowPathOptions.findIndex(v => v.id === e)
      this.form.roleId = this.flowPathOptions[i].roleId
      try {
        const res = await getFlowTempInfo(this.flowPathOptions[i].templateName)
        const nodeList = res.data.nodeList
        nodeList.shift()
        for (const item of nodeList) {
          let nodeVariate = ''
          const arr = []
          for (const v of item.userList) {
            if (v.variable) {
              v.username = v.username.substring(2, 13)
            }
            arr.push(v.username)
          }
          nodeVariate = arr.join()

          // 指定审核人赋值
          let nodePerson = null
          if (!item.userList[0].variable) {
            nodePerson = nodeVariate
          } else {
            nodePerson = null
          }
          this.form.flowPathNodePersonModels.push({
            nodePersonName: item.name,
            nodeVariate,
            nodePerson,
            nodePersonId: null,
            variable: item.userList[0].variable
          })
        }
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    handleNodePersonSelectionChange(val) {
      this.selection.nodePerson = val
    },
    selectNodePerson(index) {
      this.nodePersonIndex = index
      this.showObj.nodePerson = true
      this.getNodePersonDialog()
    },
    nodePersonConfirm() {
      if (this.selection.nodePerson.length > 1) {
        this.$message.warning('只能选择一位审批人！')
      } else {
        this.showObj.nodePerson = false
        console.log(this.selection.nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePerson', this.selection.nodePerson[0].nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePersonId', this.selection.nodePerson[0].nodePersonId)
      }
    },
    nodePersonClose() {
      this.showObj.nodePerson = false
    },
    // 配件
    addMountingsLine() {
      // if (!this.form.salesOrganizationId || !this.form.channelOfDistributionId || !this.form.productTeamId || !this.form.salesCode) {
      //   this.$message.warning('请先选择单据类型、销售组织、分销渠道、产品组，再添加订单明细')
      //   return
      // }
      this.showObj.mountings = true
      this.getMountings()
    },
    delectMountingsLine() {
      this.form.mountingsList = []
    },
    async getMountings(type = '') {
      if (type === 'refresh') {
        this.pagination.mountings.current = 1
      }
      this.loadingObj.mountings = true
      const reponse = await getMountingsApi(this.condition.mountings, this.pagination.mountings)
      const { current, total, size, records } = reponse.data
      this.dialog.mountings = records
      this.pagination.mountings.total = total
      this.pagination.mountings.current = current
      this.pagination.mountings.size = size
      this.loadingObj.mountings = false
    },
    handleMountingsDelete(index) {
      this.form.mountingsList.splice(index, 1)
    },
    handleMountingsChange(val) {
      this.selection.mountings = val
      for (const item of this.selection.mountings) {
        if (item.id) {
          delete item.id
        }
      }
    },
    mountingsConfirm() {
      const arr = JSON.parse(JSON.stringify(this.form.mountingsList))
      if (arr !== null && arr.length > 0) {
        this.form.mountingsList = mergeObjectArrayWithoutDuplicates(arr, this.selection.mountings, 'productCode')
      } else {
        this.form.mountingsList = this.selection.mountings
      }
      this.form.mountingsList.forEach((item, index) => {
        if (!item?.previewArr) {
          this.$set(this.form.mountingsList[index], 'previewArr', [])
        }
      })
      if (this.taxRatio) {
        this.form.mountingsList.forEach((item, index) => {
          this.$set(this.form.mountingsList[index], 'taxRatio', this.taxRatio)
        })
      }
      this.showObj.mountings = false
    },
    mountingsClose() {
      this.showObj.mountings = false
    },
    // 废料
    addFlotsamLine() {
      this.showObj.flotsam = true
      this.getFlotsam()
    },
    delectFlotsamLine() {
      this.form.flotsamList = []
    },
    async getFlotsam(type = '') {
      if (type === 'refresh') {
        this.pagination.flotsam.current = 1
      }
      this.loadingObj.flotsam = true
      const reponse = await getFlotsamApi(this.condition.flotsam, this.pagination.flotsam)
      const { current, total, size, records } = reponse.data
      this.dialog.flotsam = records
      this.pagination.flotsam.total = total
      this.pagination.flotsam.current = current
      this.pagination.flotsam.size = size
      this.loadingObj.flotsam = false
    },
    handleFlotsamDelete(index) {
      this.form.flotsamList.splice(index, 1)
    },
    handleFlotsamChange(val) {
      this.selection.flotsam = val
      for (const item of this.selection.flotsam) {
        if (item.id) {
          delete item.id
        }
      }
    },
    flotsamConfirm() {
      const arr = JSON.parse(JSON.stringify(this.form.flotsamList))
      if (arr !== null && arr.length > 0) {
        this.form.flotsamList = mergeObjectArrayWithoutDuplicates(arr, this.selection.flotsam, 'productCode')
      } else {
        this.form.flotsamList = this.selection.flotsam
      }
      for (const item of this.form.flotsamList) {
        item.productType = 2
        item.isParts = 0
        item.unit = 'T'
      }
      this.form.flotsamList.forEach((item, index) => {
        if (!item?.previewArr) {
          this.$set(this.form.flotsamList[index], 'previewArr', [])
        }
      })
      if (this.taxRatio) {
        this.form.flotsamList.forEach((item, index) => {
          this.$set(this.form.flotsamList[index], 'taxRatio', this.taxRatio)
        })
      }
      console.log(this.form.flotsamList)
      this.showObj.flotsam = false
    },
    flotsamClose() {
      this.showObj.flotsam = false
    },
    // 上传图片弹窗
    handleUploadPictures(index, type) {
      this.picturesIndex = index
      this.picturesType = type

      this.showObj.pictures = true
    },
    // 关闭图片弹窗
    picturesClose() {
      console.log(this.form[this.picturesType][this.picturesIndex].crmBidModuleOrderAccessoryModels)
      const picturesArr = this.form[this.picturesType][this.picturesIndex].crmBidModuleOrderAccessoryModels || []
      this.form[this.picturesType][this.picturesIndex].previewArr = []
      console.log(this.form[this.picturesType][this.picturesIndex].previewArr, 1)
      const arr = []
      if (picturesArr.length > 0) {
        for (const item of picturesArr) {
          arr.push(this.appUrl + item.accessoryUrl)
        }
      }
      this.$set(this.form[this.picturesType][this.picturesIndex], 'previewArr', arr)
      console.log(this.form[this.picturesType][this.picturesIndex].previewArr, 2)
      this.picturesIndex = null
      this.picturesType = null
      this.showObj.pictures = false
    },
    // 打开公式弹窗
    handleFormula(item) {
      this.showObj.formula = true
      this.getFormula(item.productCode)
    },
    async getFormula(productCode) {
      const reponse = await templateFormulaGet({ bidModuleOrderId: this.form.id, productCode })
      this.formulaArr = reponse.data
      // console.log(reponse.data)
    },
    addformulaLine(i) {
      this.formulaArr[i].crmBidFormulaTemplateLineModels = this.formulaArr[i].crmBidFormulaTemplateLineModels || []
      this.formulaArr[i].crmBidFormulaTemplateLineModels.push({ note: '', companyInfoId: this.formulaArr[i].companyInfoId, bidFormulaTemplateId: this.formulaArr[i].id })
    },
    // 公式弹窗明细行
    handleDormulaDelete(i, lineIndex) {
      this.formulaArr[i].crmBidFormulaTemplateLineModels.splice(lineIndex, 1)
    },
    async submitFormula() {
      for (const item of this.formulaArr) {
        if (item.crmBidFormulaTemplateLineModels && item.crmBidFormulaTemplateLineModels.length > 0) {
          const arr = []
          const models = JSON.parse(JSON.stringify(item.crmBidFormulaTemplateLineModels))
          models.forEach((v, i) => {
            if (v.note) {
              v.seq = i
              arr.push(v)
            }
          })
          console.log(arr)
          item.crmBidFormulaTemplateLineModels = arr
        }
      }
      const { message, data } = await templateFormulaSaveOrUpdate(this.formulaArr)
      this.$message({
        type: 'success',
        message: message
      })
      this.formulaClose()
    },
    formulaClose() {
      this.showObj.formula = false
      this.formulaArr = []
    },
    // 外部参考物料
    addRdmWaste(index) {
      this.rdmWasteIndex = index
      this.showObj.rdmWaste = true
      this.getRdmWaste()
    },
    // delectRdmWasteLine() {
    //   this.form.flotsamList = []
    // },
    async getRdmWaste(type = '') {
      if (type === 'refresh') {
        this.pagination.rdmWaste.current = 1
      }
      this.loadingObj.rdmWaste = true
      const data = {
        name: this.condition.rdmWaste.rdmWasteName,
        pagination: this.pagination.rdmWaste
      }
      const reponse = await selectWastePage(data)
      const { current, total, size, records } = reponse.data
      this.dialog.rdmWaste = records
      this.pagination.rdmWaste.total = total
      this.pagination.rdmWaste.current = current
      this.pagination.rdmWaste.size = size
      this.loadingObj.rdmWaste = false
    },
    // handleRdmWasteDelete(index) {
    //   this.form.flotsamList.splice(index, 1)
    // },
    handleRdmWasteChange(val) {
      this.selection.rdmWaste = val
      for (const item of this.selection.rdmWaste) {
        if (item.id) {
          delete item.id
        }
      }
    },
    rdmWasteConfirm() {
      if (this.selection.rdmWaste.length > 1) {
        this.$message.warning('只能选择一个外部参考物料！')
      } else {
        console.log(this.selection.rdmWaste)
        this.form.flotsamList[this.rdmWasteIndex].rdmWasteCode = this.selection.rdmWaste[0].code
        this.$set(this.form.flotsamList[this.rdmWasteIndex], 'rdmWasteName', this.selection.rdmWaste[0].name)
        this.rdmWasteClose()
      }
    },
    rdmWasteClose() {
      this.rdmWasteIndex = null
      this.showObj.rdmWaste = false
    },
    selectClient(id, type) {
      this.bidModuleOrderLineId = id
      this.bidModuleOrderType = type
      this.showObj.client = true
      this.getClientDialog()
    },
    async getClientDialog() {
      this.loadingObj.client = true
      this.condition.client.bidModuleOrderId = this.form.id
      this.condition.client.bidModuleOrderLineId = this.bidModuleOrderLineId
      const reponse = await getCustomerBidPage(this.condition.client, this.pagination.client)
      const { current, total, size, records } = reponse.data
      this.dialog.client = records
      this.pagination.client.total = total
      this.pagination.client.current = current
      this.pagination.client.size = size
      this.loadingObj.client = false
    },
    handleClientSelectionChange(val) {
      this.selection.client = val
    },
    clientClose() {
      this.bidModuleOrderLineId = null
      this.bidModuleOrderType = null
      this.dialog.client = []
      this.showObj.client = false
    },
    // 客户
    selectPublish() {
      this.showObj.publish = true
      this.getPublishDialog()
    },
    async getPublishDialog() {
      this.loadingObj.publish = true
      this.condition.publish.bidModuleOrderId = this.form.id
      this.condition.publish.bidModuleOrderLineId = this.bidModuleOrderLineId

      const reponse = await getCustomerApplyModels(this.condition.publish, this.pagination.publish)
      const { current, total, size, records } = reponse.data
      this.dialog.publish = records
      this.pagination.publish.total = total
      this.pagination.publish.current = current
      this.pagination.publish.size = size
      this.loadingObj.publish = false
    },

    handlePublishSelectionChange(val) {
      this.selection.publish = val
    },
    publishConfirm() {
      console.log(this.selection.publish)
      if (this.selection.publish.length <= 0) {
        this.$message.warning('请选择客户再确认发布')
        return
      }
      this.loadingObj.publish = true
      const data = []
      for (const item of this.selection.publish) {
        data.push({ bidModuleOrderId: this.form.id, bidModuleOrderLineId: this.bidModuleOrderLineId, customerApplyId: item.id })
      }
      publishes({ crmBidModuleCustomerModels: data }).then((response) => {
        this.$message.success('选择成功')
        this.getClientDialog()
      }).finally(() => {
        this.publishClose()
        this.loadingObj.publish = false
      })
    },
    publishConfirmAll() {
      this.$confirm('请确认是否选择所有客户', '提示', { type: 'warning' }).then(
        () => {
          this.loadingObj.publish = true
          publishesAll({ isPushAll: 2, bidModuleOrderId: this.form.id, bidModuleOrderLineId: this.bidModuleOrderLineId }).then((response) => {
            this.$message.success('选择成功')
            this.getClientDialog()
          })
        }
      )
    },
    publishClose() {
      // this.bidModuleOrderId = null
      this.showObj.publish = false
    },
    // 删除投标客户
    handleClientDelete(id) {
      this.$confirm('请确认是否删除此数据', '提示', { type: 'warning' }).then(
        () => {
          deleteByCustomerBidId(id).then((response) => {
            this.$message.success('删除成功')
            this.getClientDialog()
          })
        }
      )
    },
    async getData() {
      if (!this.editId) return
      this.loading = true
      try {
        const response = await get(this.editId)
        const { data } = response
        this.form = data
        this.form.bidStatus = data.bidStatus.toString()
        // this.form.mountingsList = []
        // this.form.flotsamList = []
        this.$set(this.form, 'mountingsList', [])
        this.$set(this.form, 'flotsamList', [])
        console.log(this.form)
        this.form.flowPathTemplateId = this.form.flowPathTemplateId === 0 ? null : this.form.flowPathTemplateId
        console.log(this.form.crmBidModuleOrderLineModels)
        if (this.form.crmBidModuleOrderLineModels && this.form.crmBidModuleOrderLineModels.length > 0) {
          for (const item of this.form.crmBidModuleOrderLineModels) {
            console.log(item.crmBidModuleOrderAccessoryModels)
            item.previewArr = []
            if (item.crmBidModuleOrderAccessoryModels && item.crmBidModuleOrderAccessoryModels.length > 0) {
              for (const v of item.crmBidModuleOrderAccessoryModels) {
                item.previewArr.push(this.appUrl + v.accessoryUrl)
              }
            }
            console.log(item)
            if (item.productType === 1) {
              this.form.mountingsList.push(item)
            } else {
              this.form.flotsamList.push(item)
            }
          }
        }
        // if (this.form.mountingsList.length <= 0 && this.form.flotsamList.length > 0) {
        //   this.activePaneName = 'flotsam'
        // }
        this.loading = false
        // this.$nextTick(() => {
        //   this.$refs.elTable.doLayout()
        // })
      } catch (error) {
        this.loading = false
      }
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$router.push({ query: {} })
      this.$emit('close')
    },
    async submitForm(formName, isClose = true, cb) {
      // ---- 需要手工填写此代码 -----
      this.$refs[formName].validate(async (valid, obj) => {
        if (valid) {
          // ---- 需要手工填写此代码 -----
          try {
            this.loading = true

            const formData = JSON.parse(JSON.stringify(this.form))
            // 没有送达方就赋值成售达方

            formData.crmBidModuleOrderLineModels = formData.mountingsList.concat(formData.flotsamList)
            if (formData.crmBidModuleOrderLineModels.length <= 0) {
              this.$message.warning('投标明细不能为空')
              this.loading = false
              return
            }
            console.log(formData.crmBidModuleOrderLineModels)
            delete formData.mountingsList
            delete formData.flotsamList
            const { message, data } = await saveOrUpdate(formData)
            this.$message({
              type: 'success',
              message: message
            })
            this.form.id = this.form.id || data
            await this.getData()
            this.loading = false
            if (cb) {
              await cb()
            }
            if (isClose) {
              this.handleClose()
            }
          } catch (error) {
            this.loading = false
          }
        } else {
          for (const key in obj) {
            this.$message({
              type: 'warning',
              message: obj[key][0].message
            })
            return false
          }
          return false
        }
      })
    },
    flowLoad(e) {
      this.flowOptions = e
      this.$refs.flow.validatorForm.push(this.$refs.isProceeds)
    },
    flowRejectTo(isAssignee, nodeName) {
      if (isAssignee && nodeName === '开始') {
        this.isRejectTo = false
      } else {
        if (this.form.bidStatus > 1) {
          this.isRejectTo = true
        } else {
          this.isRejectTo = false
        }
      }
    },
    flowRefresh() {
      this.getData()
      this.handleClose()
    },
    // 流程提交
    async onComplete() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        // await this.getData();
        // 在执行提交
        await this.$refs.flow.onComplete()
        this.handleClose()
      })
    },
    // 保存并提交
    async saveAndSubmit() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        await this.submit()
      })
    },
    async submit() {
      try {
        this.loading = true
        const response = await submit(this.form.id)
        this.form.flowId = response.data
        this.loading = false
        this.handleClose()
        this.getData()
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>
<style  scoped>
.blueBtn {
  font-size: 11px;
  color: rgb(64, 158, 255);
  margin: 0 2px;
  cursor: pointer;
}
</style>

